import PhoneMockup from "./PhoneMockup";
import ProductVideo from "./ProductVideo";
import { products } from "@/mocks/products";

const feats = [
  {
    icon: "ri-smartphone-line",
    title: "Conteúdo vertical",
    text: "9:16, em tela cheia, como o cliente já consome.",
  },
  {
    icon: "ri-arrow-up-down-line",
    title: "Navegação por swipe",
    text: "Deslizar para cima. Simples e familiar.",
  },
  {
    icon: "ri-apps-2-line",
    title: "Categorias",
    text: "Burgers, pizzas, drinks — tudo organizado.",
  },
  {
    icon: "ri-star-line",
    title: "Destaque de produtos",
    text: "Coloque seus campeões no centro.",
  },
];

const showcase = [products[0], products[2], products[1], products[3]];

export default function PlayMenuIntro() {
  return (
    <section
      id="produto"
      className="grain relative overflow-hidden bg-foreground-950 py-24 md:py-32"
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_85%_15%,oklch(var(--primary-500)/0.18),transparent_55%)]" />

      <div className="relative z-10 mx-auto max-w-6xl px-4 md:px-6">
        <div className="reveal mx-auto max-w-3xl text-center">
          <span className="mb-5 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-accent-500">
            <span className="h-px w-6 bg-current" />
            A PlayMenu
            <span className="h-px w-6 bg-current" />
          </span>
          <h2 className="font-heading text-4xl font-bold leading-[1.08] tracking-tight text-foreground-50 md:text-6xl">
            Não criamos apenas outro cardápio digital.
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-foreground-300 md:text-lg">
            Criamos um cardápio feito para <span className="text-primary-500">despertar desejo</span>.
            Cada produto ganha vida em vídeo — interface vertical, categorias e
            navegação por swipe.
          </p>
        </div>

        {/* Fileira de aparelhos com vídeos reais */}
        <div className="mt-16 grid grid-cols-2 gap-4 sm:gap-6 lg:grid-cols-4">
          {showcase.map((product, i) => (
            <div
              key={product.id}
              className="reveal mx-auto w-full max-w-[250px]"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="transition-transform duration-500 hover:-translate-y-2">
                <PhoneMockup>
                  <ProductVideo
                    src={product.video}
                    poster={product.image}
                    alt={product.name}
                  />
                </PhoneMockup>
              </div>
              <p className="mt-4 text-center text-sm font-semibold text-foreground-200">
                {product.name}
              </p>
            </div>
          ))}
        </div>

        {/* Features */}
        <div className="mt-16 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {feats.map((feat, i) => (
            <div
              key={feat.title}
              className="reveal flex flex-col gap-3 rounded-xl border border-foreground-800/60 bg-secondary-500/25 p-6"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/15 text-primary-500">
                <i className={`${feat.icon} text-xl`} aria-hidden="true" />
              </span>
              <h3 className="font-heading text-base font-bold text-foreground-50">
                {feat.title}
              </h3>
              <p className="text-sm leading-relaxed text-foreground-400">{feat.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}